import * as React from 'react';
import BottomNavigation from '@mui/material/BottomNavigation';
import { styled } from '@mui/material';

const StyledBottomNavigation = styled((props) => <BottomNavigation {...props} />)({
  height: '52px',
});

export default StyledBottomNavigation;
